import { ModalForm } from '@ant-design/pro-components';
import { Form, TreeSelect } from 'antd';
import PropTypes from 'prop-types';
import { getOperationEntityParentOptions } from '../utils/operation-entities';

const OperationEntityBatchMoveForm = ({ entities, entityIds, onFinish, onOpenChange, open }) => {
  const treeData = getOperationEntityParentOptions(entities).map(({ label, value }) => ({
    title: label,
    value,
  }));

  return (
    <ModalForm
      key={entityIds.join('|')}
      title={`批量调整上级（${entityIds.length}）`}
      open={open}
      modalProps={{ destroyOnHidden: true }}
      onFinish={({ parentId }) => onFinish({ action: 'move', entityIds, parentId })}
      onOpenChange={onOpenChange}
    >
      <Form.Item
        name="parentId"
        label="目标上级实体"
        rules={[{ required: true, message: '请选择目标上级实体' }]}
      >
        <TreeSelect
          showSearch
          treeData={treeData}
          treeDefaultExpandAll
          treeNodeFilterProp="title"
        />
      </Form.Item>
    </ModalForm>
  );
};

OperationEntityBatchMoveForm.propTypes = {
  entities: PropTypes.arrayOf(
    PropTypes.shape({
      enabled: PropTypes.bool.isRequired,
      id: PropTypes.string.isRequired,
      isStore: PropTypes.bool,
      name: PropTypes.string.isRequired,
      parentId: PropTypes.string,
    }),
  ).isRequired,
  entityIds: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  onFinish: PropTypes.func.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default OperationEntityBatchMoveForm;
